import React, { useCallback, useEffect, useState } from 'react';
import { adminService } from '../../services';
import { AdminPageHeader, DataTable, SearchField, SubTabs, Btn, money, shortDate, useAdminShell } from '../../components/admin/shell';

/**
 * MONEY › WALLETS (Oct 27 2026) — everyone Portal owes money to, largest first: the balance
 * they can cash out, what sits in escrow for their events, and the counters. The header says
 * what the whole platform owes right now. A row opens the person drawer, whose FULL RECORD
 * is the ledger for that one wallet; ADJUST WALLET lives there too (`wallets · adjust`).
 * Read-only here on purpose: this page is for reading the book, never for writing in it.
 */
export default function WalletsPage() {
  const { openPerson, canSeePeople } = useAdminShell();
  const [scope, setScope] = useState('money');
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [totals, setTotals] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await adminService.getWallets(page, { search: query, all: scope === 'all' });
    setLoading(false);
    if (r.success) { setRows(r.data.wallets || []); setTotal(r.data.total || 0); setTotals(r.data.totals || null); }
  }, [page, query, scope]);
  useEffect(() => { load(); }, [load]);
  const submitSearch = () => { setQuery(search.trim()); setPage(1); };

  const meta = totals
    ? `Portal owes ${money(totals.balanceCents)} in balances and holds ${money(totals.escrowCents)} in escrow, across ${totals.walletsWithMoney} of ${totals.wallets} wallets.`
    : 'Every wallet that holds money, largest first.';

  return (
    <>
      <AdminPageHeader section="wallets" meta={meta} />
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SubTabs tabs={[{ key: 'money', label: 'WITH MONEY' }, { key: 'all', label: 'EVERYONE' }]} active={scope} onChange={(k) => { setScope(k); setPage(1); }} />
          <SearchField value={search} onChange={setSearch} onSubmit={submitSearch} placeholder="SEARCH EMAIL, NAME OR HANDLE" />
          <Btn variant="solid" size="card" onClick={submitSearch}>SEARCH</Btn>
        </div>
        <DataTable
          columns={[
            { key: 'email', label: 'USER', fr: 2.2, render: (w) => <>{w.email}{w.isTestAccount ? <span className="ml-2 text-[10px] font-bold">DEMO</span> : null}</> },
            { key: 'displayName', label: 'NAME', fr: 1.3, render: (w) => (w.displayName ? <>{w.displayName}{w.handle ? <span className="ml-2 text-[#6B7280]">@{w.handle}</span> : null}</> : w.handle ? `@${w.handle}` : '—') },
            { key: 'balance', label: 'BALANCE', fr: 0.9, right: true, render: (w) => <span className={w.balance < 0 ? 'text-[#DC2626]' : 'font-bold'}>{money(w.balance)}</span> },
            { key: 'escrow', label: 'ESCROW', fr: 0.9, right: true, render: (w) => <span className={w.escrow < 0 ? 'text-[#DC2626]' : ''}>{money(w.escrow)}</span> },
            { key: 'totalEarned', label: 'EARNED', fr: 0.9, right: true, render: (w) => <span className="text-[#15803D]">{money(w.totalEarned)}</span> },
            { key: 'totalSpent', label: 'SPENT', fr: 0.9, right: true, render: (w) => money(w.totalSpent) },
            { key: 'transactionCount', label: 'ENTRIES', fr: 0.7, right: true, render: (w) => w.transactionCount },
            { key: 'lastActivityAt', label: 'LAST ENTRY', fr: 0.9, render: (w) => (w.lastActivityAt ? shortDate(w.lastActivityAt) : '—') },
          ]}
          rows={rows}
          rowKey={(w) => w.userId}
          loading={loading}
          total={total}
          page={page}
          pageSize={30}
          onPage={setPage}
          onRowClick={canSeePeople ? (w) => openPerson(w.userId) : undefined}
          empty={scope === 'all' ? 'NO WALLETS MATCH.' : 'NOBODY HOLDS MONEY RIGHT NOW.'}
        />
      </div>
    </>
  );
}
